import {Component, OnDestroy} from '@angular/core';
import {
  AuthService,
  CompanyService,
  FirebaseService,
  RequiredVerificationService
} from "@brightside-web/desktop/data-access/shared";
import {Subscription} from "rxjs";
import {Environment} from "@brightside-web/micro/core/environment";
import {Router} from "@angular/router";
import {
  BsCacheService
} from '@brightside-web/desktop/data-access/core-services';
import {RegistrationService} from "@brightside-web/desktop/data-access/onboarding";

@Component({
  selector: 'brightside-web-client-type',
  templateUrl: './client-type.component.html',
  styleUrls: ['./client-type.component.scss']
})
export class ClientTypeComponent implements OnDestroy {
  _company: string;

  set company(value:string) {
    this._company = value;
    this.article = this.getPrefixArticle(this.company);
  }

  get company() : string {
    return this._company;
  }

  _getCompanyAttempts = 0;
  displayDefaultIcon = false;

  set getCompanyAttempts(value: number) {
    this._getCompanyAttempts = value;
  }

  get getCompanyAttempts() {
    return this._getCompanyAttempts;
  }

  cdnUrl: string;
  sub = new Subscription();
  analyticsName = 'select_client_type';
  article: string;
  processing: boolean;
  userFromSubDomain: boolean;

  constructor(
    private authService: AuthService,
    private companyService: CompanyService,
    private env: Environment,
    private router: Router,
    private analytics: FirebaseService,
    private requiredVeriService: RequiredVerificationService,
    private regSvc: RegistrationService,
    private bsCacheService: BsCacheService
    ) {
    this.cdnUrl = this.env.cdnUrl;
    Promise.all([
      this.bsCacheService.getItem('fromSubdomain'),
      this.bsCacheService.getItem('employmentType')
    ]).then(
      values => {
        this.userFromSubDomain = values[0] ?? false;
        if (this.regSvc.skipAccountCreation) {
          this.bsCacheService.setItem('employmentType',
              this.regSvc.referralItems?.['employmentType'] ?? values[1]);
          this.router.navigate(['/eligibility/identity']);
        }
      }
    )
  }

  ngOnInit() {
    this.sub.add(
      this.companyService.company.subscribe(
        value => {
          this.getCompanyAttempts++;
          if (value) {
            this.company = value;
          }
        }
      )
    )
  }

  getPrefixArticle(stringVal: string): string {
    const vowels = ["a", "e", "i", "o", "u"]
    for (const vowel of vowels) {

      if (stringVal && stringVal.startsWith(vowel)) {
        return "an";
      }
    }
    return "a"
  }

  goBack() {
    this.bsCacheService.removeItem('fromSubdomain');
    this.analytics.logEvent(`${this.analyticsName}_dismissed`);
    this.router.navigate(['eligibility/select-employer']);
  }

  submitClientType(type: string) {
    this.processing = true;
    if (type === 'neither') {
      this.analytics.logEvent(`${this.analyticsName}_dismissed`);
      this.goBack();
    } else {
      this.analytics.logEvent(`${this.analyticsName}_tapped`);
      this.setItemsForVerificaitonSvc(this.company, type);
    }
  }

  setItemsForVerificaitonSvc(company: string, employmentType: string) {
    this.requiredVeriService.company = this.company;
    this.requiredVeriService.employmentType = employmentType;
    this.bsCacheService.setItem('employmentType', employmentType).then(
      () => {
        this.router.navigate(['/eligibility/identity']);
      }
    );
  }

  logoLoaded(event:unknown) {

  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

}
